import {Component, HostBinding, inject} from '@angular/core';
import {IBaseComponent} from '../ibase/ibase.component';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';

/**
 * Base modal component
 */
@Component({
    selector: 'app-ibase-modal',
    template: ''
})
export abstract class IBaseModalComponent<t_Component, t_Config> extends IBaseComponent {
    @HostBinding('class.app-ibase-modal')
    protected _isIBaseCRUModalComponent = true;

    protected ref: DynamicDialogRef<t_Component> = inject(DynamicDialogRef<t_Component>);
    protected config: DynamicDialogConfig<t_Config> = inject(DynamicDialogConfig<t_Config>);
}
